/* eslint-disable */
import {createSlice, PayloadAction} from '@reduxjs/toolkit';

const initialState: LocationState = {
    lat: 0,
    long: 0
};

export interface LocationState {
    lat:number,
    long: number,
}


export const locationSlice = createSlice({
    name: 'locationChange',
    initialState,
    reducers: {
        updateLocation: (state, action: PayloadAction<LocationState>) => {
            state.lat = action.payload.lat;
            state.long = action.payload.long;
        },
        resetLocation:() => initialState
    },
});

export default locationSlice.reducer;

// export methods
export const { updateLocation, resetLocation } = locationSlice.actions;
